import { cn } from '@/lib/utils';
import type { VehicleListing } from '@/models/types';
import { Button } from '../../ui/button';
import { NUMBER_OF_KEYS_OPTIONS_MAP } from './number-of-keys-selector';

export const VehicleNumberOfKeysBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  className,
  buttonVariant = 'ghost',
}: {
  value: VehicleListing['num_of_keys'];
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
  buttonVariant?: 'outline' | 'ghost';
}) => {
  const option = NUMBER_OF_KEYS_OPTIONS_MAP.find(
    (option) => option.value === value.toString(),
  );

  return (
    <Button
      variant={buttonVariant}
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {option?.icon}
      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {
            NUMBER_OF_KEYS_OPTIONS_MAP.find(
              (option) => option.value === value.toString(),
            )?.label
          }
        </p>
      )}
    </Button>
  );
};
